import React from 'react';

const FESkills = () => {
    return (
        <React.Fragment>
            <div className="block-title">
                <h3>Front End Skills</h3>
            </div>
            <div className="skills-info">
                <h4>HTML and CSS</h4>
                <div className="skill-container">
                    <div className="skill-percentage skill-6" />
                </div>
                <h4>JavaScript and TypeScript</h4>
                <div className="skill-container">
                    <div className="skill-percentage skill-6" />
                </div>
                <h4>React</h4>
                <div className="skill-container">
                    <div className="skill-percentage skill-6" />
                </div>
                <h4>Bootstrap</h4>
                <div className="skill-container">
                    <div className="skill-percentage skill-7" />
                </div>
                <h4>Material UI</h4>
                <div className="skill-container">
                    <div className="skill-percentage skill-4" />
                </div>
                <h4>Webpack</h4>
                <div className="skill-container">
                    <div className="skill-percentage skill-5" />
                </div>
                <h4>NPM</h4>
                <div className="skill-container">
                    <div className="skill-percentage skill-6" />
                </div>
                <h4>Data Visualization</h4>
                <div className="skill-container">
                    <div className="skill-percentage skill-5" />
                </div>
            </div>
        </React.Fragment>
    );
};

export default FESkills;